<div fxLayout="column">
    <div fxFlex="1 1 auto" fxLayout="row">
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('LEFT')"
            class="move-selected-button p-button-rounded">
            <i class="fa fa-arrow-circle-left"></i>
            Move Left
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('RIGHT')" class="move-selected-button">
            Move Right
            <i class="fa fa-arrow-circle-right"></i>
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('UP')" class="move-selected-button">
            Move Up
            <i class="fa fa-arrow-circle-up"></i>
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('DOWN')" class="move-selected-button">
            Move Down
            <i class="fa fa-arrow-circle-down"></i>
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('SHRINK')" class="move-selected-button">
            Smaller
            <i class="fa fa-minus-circle"></i>
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="moveSelected('GROW')" class="move-selected-button">
            Larger
            <i class="fa fa-plus-circle"></i>
        </button>
        <button type="button" fxFlex="1 1 auto" (click)="resetLayoutsToDefault()" class="reset-layout-button">
            Reset Layout to Default
            <i class="fa fa-reset"></i>
        </button>
    </div>
    <div *ngFor="let componenBoxes of componentBoxRows; let r=index" fxLayout="row"
        [class]="exceedsAllowedSpan(componenBoxes) ? 'layout-list-exceeded' : 'layout-list'">
        <div [fxFlex]="'1 1 ' + ((ccBox.colSpan/12)*100) + '%'" class="layout-box" fxLayout="column"
            *ngFor="let ccBox of componenBoxes; let c=index">
            <div *ngFor="let componentConfig of ccBox.componentConfigs; let stackIndex=index" fxFlex="1 1 auto"
                fxLayout="column"
                [class]="isSelected(r,c,stackIndex) ? 'layout-box-component-selected' : 'layout-box-component'"
                (click)="setSelected(r,c,stackIndex)">
                <div fxFlex="0 1 auto" fxLayout="row">
                    <button type="button" fxFlex="1 1 auto" (click)="move(r,c,'UP',stackIndex)" class="movement-button">
                        <i class="fa fa-arrow-circle-up"></i>
                    </button>
                </div>
                <div fxFlex="5 1 auto" fxLayout="row">
                    <button type="button" fxFlex="0 1 auto" (click)="move(r,c,'LEFT',stackIndex)"
                        class="movement-button">
                        <i class="fa fa-arrow-circle-left"></i>
                    </button>
                    <div fxFlex="1 1 auto" fxLayout="column">
                        <span fxFlex="1 1 auto" class="component-title">
                            {{componentConfig.title}}
                        </span>
                        <div fxFlex="5 1 auto" fxLayout="row">
                            <button type="button" fxFlex="0 1 auto" (click)="move(r,c,'SHRINK',stackIndex)"
                                class="movement-button">
                                <i class="fa fa-minus-circle shrink-button"></i>
                            </button>
                            <i fxFlex="1 1 auto" [class]="getIcon(componentConfig) + ' component-icon'"
                                [matTooltip]="componentSummary(componentConfig)"
                                matTooltipClass="multiline-tooltip"></i>
                            <button type="button" fxFlex="0 1 auto" (click)="move(r,c,'GROW',stackIndex)"
                                class="movement-button">
                                <i class="fa fa-plus-circle grow-button"></i>
                            </button>
                        </div>
                    </div>
                    <button type="button" fxFlex="0 1 auto" (click)="move(r,c,'RIGHT',stackIndex)"
                        class="movement-button">
                        <i class="fa fa-arrow-circle-right"></i>
                    </button>
                </div>
                <div fxFlex="0 1 auto" fxLayout="row">
                    <button type="button" fxFlex="1 1 auto" (click)="move(r,c,'DOWN',stackIndex)"
                        class="movement-button">
                        <i class="fa fa-arrow-circle-down"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>